<div class="task-search-filter">
  <div class="filter-header mb-3" *ngIf="!searchMode">
    <h6 class="mb-0">
      <mat-icon class="me-2">filter_list</mat-icon>
      Filter Tasks
    </h6>
  </div>

  <div class="filter-body compact-inputs">

    <!-- SEARCH MODE: single input → searches title, description & assignee -->
    <div *ngIf="searchMode" class="search-mode-wrap">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Search by Title, Description or Assignee</mat-label>
        <input matInput [(ngModel)]="filterOptions.searchText" (ngModelChange)="onSearchInput($event)"
          (focus)="onSearchFocus()" (blur)="onSearchBlur()" placeholder="Type to search..." autocomplete="off" />
        <mat-icon matSuffix class="icon-pd-none text-secondary">search</mat-icon>
        <button *ngIf="filterOptions.searchText" matSuffix mat-icon-button class="icon-pd-none" (click)="clearSearch()">
          <mat-icon class="icon-compact">close</mat-icon>
        </button>
      </mat-form-field>

      <!-- Assignee suggestions when input matches a user name -->
      <div class="assignee-suggestions" *ngIf="showSuggestions && suggestions.length > 0">
        <div *ngFor="let name of suggestions" class="suggestion-item" (mousedown)="pickSuggestion(name)">
          <span class="suggestion-avatar">{{ name.charAt(0).toUpperCase() }}</span>
          <span>{{ name }}</span>
        </div>
      </div>
    </div>

    <!-- FILTER MODE: original layout, completely untouched -->
    <ng-container *ngIf="!searchMode">
      <!-- Search Text -->
      <div class="row mb-3">
        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100 mb-2">
            <mat-label>Search by Title or Description</mat-label>
            <input matInput [(ngModel)]="filterOptions.searchText" (ngModelChange)="onFilterChange()" placeholder="" />
            <mat-icon matSuffix class="icon-pd-none text-secondary">search</mat-icon>
          </mat-form-field>
        </div>
      </div>

      <!-- Priority & Assignee -->
      <div class="row mb-3">
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="w-100 mb-2">
            <mat-label>Priority</mat-label>
            <mat-select [(ngModel)]="filterOptions.priority" (selectionChange)="onFilterChange()">
              <mat-option *ngFor="let option of priorityOptions" [value]="option.value">
                {{ option.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="w-100 mb-2">
            <mat-label>Assignee</mat-label>
            <mat-select [(ngModel)]="filterOptions.assignee" (selectionChange)="onFilterChange()">
              <mat-option *ngFor="let assignee of assigneeOptions" [value]="assignee">
                {{ assignee === 'all' ? 'All Assignees' : assignee }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- Active Filters Display -->
      <div class="active-filters mb-3" *ngIf="hasActiveFilters()">
        <div class="d-flex flex-wrap gap-2">
          <span *ngIf="filterOptions.searchText" class="filter-chip">
            Search: "{{ filterOptions.searchText }}"
            <button mat-icon-button class="icon-pd-none" (click)="filterOptions.searchText = ''; onFilterChange()">
              <mat-icon class="icon-compact">close</mat-icon>
            </button>
          </span>
          <span *ngIf="filterOptions.priority !== 'all'" class="filter-chip">
            Priority: {{ getPriorityLabel(filterOptions.priority) }}
            <button mat-icon-button class="icon-pd-none" (click)="filterOptions.priority = 'all'; onFilterChange()">
              <mat-icon class="icon-compact">close</mat-icon>
            </button>
          </span>
          <span *ngIf="filterOptions.assignee !== 'all'" class="filter-chip">
            Assignee: {{ filterOptions.assignee }}
            <button mat-icon-button class="icon-pd-none" (click)="filterOptions.assignee = 'all'; onFilterChange()">
              <mat-icon class="icon-compact">close</mat-icon>
            </button>
          </span>
          <span *ngFor="let label of filterOptions.labels" class="filter-chip">
            Label: {{ label }}
            <button mat-icon-button class="icon-pd-none" (click)="removeLabel(label)">
              <mat-icon class="icon-compact">close</mat-icon>
            </button>
          </span>
        </div>
      </div>

      <!-- Actions -->
      <div class="filter-actions">
        <button mat-stroked-button color="warn" (click)="clearFilters()" class="w-100">
          <mat-icon>refresh</mat-icon>
          Clear All Filters
        </button>
      </div>
    </ng-container>

  </div>
</div>
